import { Box, Grid, Typography } from "@mui/material";
import RopCollapsibleTable from "../../../../main/components/RopCollapsibleTable/RopCollapsibleTable";
import { CollapsibleTableRowType } from "../../../../main/components/RopCollapsibleTable/RopTableCollapsibleBody";
import { TableItem, TableRowType } from "../../../../main/components/RopTable/RopTable";
import { ImpactoMetaClusterAggregated } from "../../types";

export type DetalhamentoPorAtivoTableProps = {
    clusters: ImpactoMetaClusterAggregated[];
    loading: boolean;
}

export default function DetalhamentoPorAtivoTable(props: DetalhamentoPorAtivoTableProps) {

    const items: CollapsibleTableRowType[] = props.clusters.map((cluster) => {

        const annualTarget = cluster.monthlyData['dezembro']?.target ?? cluster.ytdData.target;
        const progressPercentage = annualTarget > 0 ? (cluster.ytdData.generatedEnergy / annualTarget) * 100 : 0;
        const desvio = cluster.periodData.generatedEnergy - cluster.periodData.target;

        const rowItems: TableItem[] = [
            {
                item: cluster.clusterName,
                align: "center",
                isMobile: true,
                width: "15%",
            },
            {
                item: Number(cluster.periodData.generatedEnergy).toFixed(1) || "0.0",
                align: "center",
                isMobile: true,
                width: "12.5%",
            },
            {
                item: Number(cluster.periodData.target).toFixed(1) || "0.0",
                align: "center",
                isMobile: true,
                width: "12.5%",
            },
            {
                item: (
                    <Typography
                        sx={{
                            fontSize: "12px",
                            color: desvio >= 0 ? "#10B981" : "#EF4444",
                            fontWeight: "500"
                        }}
                    >
                        {desvio > 0 ? "+" : ""}{Number(desvio).toFixed(1)}
                    </Typography>
                ),
                align: "center",
                isMobile: true,
                width: "12.5%",
            },
            {
                item: Number(cluster.ytdData.generatedEnergy).toFixed(1) || "0.0",
                align: "center",
                isMobile: true,
                width: "12.5%",
            },
            {
                item: Number(annualTarget).toFixed(1) || "0.0",
                align: "center",
                isMobile: true,
                width: "12.5%",
            },
            {
                item: (
                    <Typography
                        sx={{
                            fontSize: "12px",
                            color: progressPercentage >= 100 ? "#10B981" : "#459CFA",
                            fontWeight: "600"
                        }}
                    >
                        {Number(progressPercentage).toFixed(1)}%
                    </Typography>
                ),
                align: "center",
                isMobile: true,
                width: "12.5%",
            },
        ]

        const historyItems: TableRowType[] = cluster.powerPlantData.map((usina) => {
            const usinaAnnualTarget = usina.monthlyData['dezembro']?.target ?? usina.ytdData.target;
            const usinaProgressPercentage = usinaAnnualTarget > 0 ? (usina.ytdData.generatedEnergy / usinaAnnualTarget) * 100 : 0;
            const usinaDesvio = usina.periodData.generatedEnergy - usina.periodData.target;

            return {
                rowItems: [
                    {
                        item: <></>,
                        align: "center",
                        isMobile: true,
                        width: "10%",
                    },
                    {
                        item: usina.usinaName,
                        align: "center",
                        isMobile: true,
                        width: "15%",
                    },
                    {
                        item: Number(usina.periodData.generatedEnergy).toFixed(1) || "0.0",
                        align: "center",
                        isMobile: true,
                        width: "12.5%",
                    },
                    {
                        item: Number(usina.periodData.target).toFixed(1) || "0.0",
                        align: "center",
                        isMobile: true,
                        width: "12.5%",
                    },
                    {
                        item: (
                            <Typography
                                sx={{
                                    fontSize: "12px",
                                    color: usinaDesvio >= 0 ? "#10B981" : "#EF4444",
                                    fontWeight: "500"
                                }}
                            >
                                {usinaDesvio > 0 ? "+" : ""}{Number(usinaDesvio).toFixed(1)}
                            </Typography>
                        ),
                        align: "center",
                        isMobile: true,
                        width: "12.5%",
                    },
                    {
                        item: Number(usina.ytdData.generatedEnergy).toFixed(1) || "0.0",
                        align: "center",
                        isMobile: true,
                        width: "12.5%",
                    },
                    {
                        item: Number(usinaAnnualTarget).toFixed(1) || "0.0",
                        align: "center",
                        isMobile: true,
                        width: "12.5%",
                    },
                    {
                        item: (
                            <Typography
                                sx={{
                                    fontSize: "12px",
                                    color: usinaProgressPercentage >= 100 ? "#10B981" : "#459CFA",
                                    fontWeight: "600"
                                }}
                            >
                                {Number(usinaProgressPercentage).toFixed(1)}%
                            </Typography>
                        ),
                        align: "center",
                        isMobile: true,
                        width: "12.5%",
                    },
                ],
            }
        })

        return {
            rowItems: rowItems,
            historyHeaders: [],
            historyRows: historyItems
        }
    })

    const itemsHeader = [
        {
            item: (<></>),
            width: "10%",
            align: "center",
            isMobile: true
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>Ativo</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "15%",
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>Real Período</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>(MWh)</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "12.5%",
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>Meta Período</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>(MWh)</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "12.5%",
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>Desvio</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>(MWh)</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "12.5%",
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>YTD Real</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>(MWh)</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "12.5%",
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>Meta Anual</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>(MWh)</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "12.5%",
        },
        {
            item: (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>Progresso</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>(%)</Typography>
                </Box>
            ),
            align: "center",
            isMobile: true,
            width: "12.5%",
        },
    ]

    return (
        <Grid item xs={12}>
            <RopCollapsibleTable
                sxCardBox={{ marginLeft: { xs: "10px", md: "0px" }, width: "100%" }}
                hover
                itemsHeaders={itemsHeader as TableItem[]}
                items={items}
                isLoading={props.loading}
                historyTableColSpan={itemsHeader.length}
            />
        </Grid>
    )
}
